import {z} from 'zod';

import {isNotNil} from 'ramda';

import i18n from '@dms/i18n';

const requiredString = z.string().min(1, i18n.t('general.validations.fieldIsRequired'));
const optionalSeriesId = z.string().nullable();

/**
 * A system definition has no branch of its own, so `branchId` stays nullable there and is
 * required for every other definition. Each record-type series is optional — an empty one falls
 * back to the default series.
 */
export const getRecordAuditSeriesDefinitionFormSchema = (isSystemDefinition: boolean) =>
  z.object({
    name: requiredString,
    branchId: isSystemDefinition
      ? z.string().nullable()
      : requiredString
          .nullable()
          .refine(isNotNil, {message: i18n.t('general.validations.fieldIsRequired')}),
    defaultSeriesId: requiredString,
    recordSeries: z.object({
      BUSINESS_CASE: optionalSeriesId,
      SERVICE_CASE: optionalSeriesId,
      SERVICE_ORDER: optionalSeriesId,
      RENTAL_ORDER: optionalSeriesId,
      VEHICLE: optionalSeriesId,
      INTEREST: optionalSeriesId,
      WORKSHOP_INTEREST: optionalSeriesId,
    }),
  });

export type RecordAuditSeriesDefinitionFormValues = z.infer<
  ReturnType<typeof getRecordAuditSeriesDefinitionFormSchema>
>;
